import { render, staticRenderFns } from "./PreviewCommunication.vue?vue&type=template&id=40d8783b&scoped=true&"
import script from "./PreviewCommunication.vue?vue&type=script&lang=js&"
export * from "./PreviewCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8783b",
  null
  
)

export default component.exports